import { AssetNetworkIcon, EmptyState, Typography } from '@libs/components';
import styled from 'styled-components';
import Bullets from '../bullets/Bullets';

type AssetNetworkIconProps = {
  isAlone?: boolean;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  background-color: ${({ theme }) => theme.colors.surface.default};
  padding: 1.6rem 0;
  margin-top: 3.6rem;
  ${({ theme }) => theme.media.tablet`
    margin-top:0;
    padding:2.4rem 0 ;
  `}
`;
export const Header = styled.div`
  padding: 0 1.6rem 1.6rem;
  ${({ theme }) => theme.media.tablet`
    padding: 0 2.4rem 1.9rem;
  `}
`;
export const Body = styled.div`
  padding: 0 1.6rem;
  ${({ theme }) => theme.media.tablet`
      padding:0 0 0 2.4rem;
  `};
`;
export const GrayBullets = styled(Bullets)`
  background-color: ${({ theme }) => theme.colors.borders.default};
  width: 0.6rem;
  height: 0.6rem;
`;
export const CustomBullets = styled(Bullets)`
  margin-bottom: 1.2rem;
  width: 0.8rem;
  height: 0.8rem;
`;
export const ListContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 7.6rem;
  padding: 0 1.6rem 0 0;
  cursor: pointer;
  ${({ theme }) => theme.media.tablet`
        padding: 0 2.4rem 0 0;
  `}
`;
export const Separator = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;
export const ImageTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1.6rem;
`;
export const DescrContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1.6rem;
  align-items: flex-end;
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.2rem;
  height: 4.2rem;
`;
export const CustomAssetNetworkIcon = styled(
  AssetNetworkIcon
)<AssetNetworkIconProps>`
  .baseNetworkIcon {
    width: ${({ isAlone }) => (isAlone ? '4.2rem' : '2.2rem ')};
    height: ${({ isAlone }) => (isAlone ? '4.2rem' : '2.2rem ')};
  }
  .networkIconWrapper {
    width: 2.2rem;
    height: 2.2rem;
    bottom: -1rem;
    right: -1.1rem;
    top: unset;
    padding: 0;
    z-index: ${({ theme }) => theme.zIndex.low};
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const CodeTypography = styled(Typography)`
  margin-left: 0.4rem;
`;
export const TextSeparator = styled.div`
  padding: 0 0.2rem;
`;
export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.4rem;
`;
export const Footer = styled.div`
  padding: 1.2rem 1.6rem 0;
  ${({ theme }) => theme.media.tablet`
         padding: 0.8rem 2.4rem 0; 

  `}
`;
export const ListWrapper = styled.div`
  &:last-child {
    .separator {
      display: none;
    }
  }
`;
export const CustomEmptyState = styled(EmptyState)`
  padding: 2.4rem 0;
  width: 20rem;
  align-self: center;
`;
